<div id="chargingStationPlacement" class="container mx-auto" data-cy="charging-station-placement">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evSimulator.steps.chargingStationPlacement.fields.chargingStationPlacement.title' | translate"
      data-cy="charging-station-placement-title"
    ></ife-title>

    <div class="flex flex-wrap md:mt-8 justify-center">
      <ife-checkbox
        [id]="chargingStationPlacement.inside"
        [attr.data-cy]="chargingStationPlacement.inside"
        class="w-full mb-8 md:mr-16 sm:w-auto"
        [value]="chargingStationPlacement.inside"
        formControlName="placement"
        [image]="'./assets/evc/img/inside.svg'"
        [caption]="
          'modules.evSimulator.steps.chargingStationPlacement.fields.chargingStationPlacement.options.inside'
            | translate
        "
      >
      </ife-checkbox>
      <ife-checkbox
        [id]="chargingStationPlacement.outsideWall"
        [attr.data-cy]="chargingStationPlacement.outsideWall"
        class="w-full mb-8 md:mr-16 sm:w-auto"
        [value]="chargingStationPlacement.outsideWall"
        formControlName="placement"
        [image]="'./assets/evc/img/outsideWall.svg'"
        [caption]="
          'modules.evSimulator.steps.chargingStationPlacement.fields.chargingStationPlacement.options.outsideWall'
            | translate
        "
      >
      </ife-checkbox>
      <ife-checkbox
        [id]="chargingStationPlacement.outsidePole"
        [attr.data-cy]="chargingStationPlacement.outsidePole"
        class="w-full mb-8 sm:w-auto"
        [value]="chargingStationPlacement.outsidePole"
        formControlName="placement"
        [image]="'./assets/evc/img/outsidePole.svg'"
        [caption]="
          'modules.evSimulator.steps.chargingStationPlacement.fields.chargingStationPlacement.options.outsidePole'
            | translate
        "
      >
      </ife-checkbox>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
